import styled from "@emotion/styled";
import { Badge, BadgeProps, Grid, Box, Typography } from "@mui/material";
import { IQuestions } from "../../interface/iRatingAnalytics";
import React from "react";

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -26,
    top: 11,
    padding: "0 6px",
  },
}));

const RenderQuestionContent = ({
  questions,
  index,
}: {
  questions: IQuestions[];
  index: number;
}): React.JSX.Element => (
  <Grid
    item
    xs={12}
    sm={6}
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1,
    }}
  >
    {questions.map((question: IQuestions) => {
      index += 1;
      return (
        <Box key={index}>
          <StyledBadge
            badgeContent={question.count}
            color="secondary"
            max={10000}
          >
            <Typography variant="body1" color="initial">
              {`${index}) ${question.name}`}
            </Typography>
          </StyledBadge>
        </Box>
      );
    })}
  </Grid>
);

export default RenderQuestionContent;
